import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbdTimeout} from './timeout';

export {NgbdTimeout} from './timeout';

@NgModule({declarations: [NgbdTimeout], exports: [NgbdTimeout], imports: [CommonModule]})
export class NgbdTimeoutModule {
}
